import type { ReactElement } from "react";

import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel/components/FiltersChip/FiltersChip";
import type { LeadPriorityScore } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";
import { StyledCheckboxFilterResultContainer } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/CheckboxFilter/styles";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type LeadScoreFilterModel from "app/pages/sales-intelligence/modules/leads-search-filters/models/LeadScoreFilter/LeadScoreFilterModel";
import {
    getLeadScoreSelectedOptions,
    removeLeadScoreSelection,
} from "app/pages/sales-intelligence/modules/leads-search-filters/models/LeadScoreFilter/leadScoreFilterValue";

const LeadScoreFilterResult = ({
    value,
    filter,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<LeadScoreFilterModel>): ReactElement | null => {
    const selectedOptions = getLeadScoreSelectedOptions(filter.options, value);

    if (!selectedOptions.length) {
        return null;
    }

    const handleRemove = (id: LeadPriorityScore): void => {
        const updatedValues = removeLeadScoreSelection(id, value);
        onFilterValueRemove?.(updatedValues);
        onFilterUpdate(updatedValues);
    };

    return (
        <StyledCheckboxFilterResultContainer data-automation="lead-score-filter-chips">
            {selectedOptions.map((item) => (
                <FiltersChip
                    key={item.value}
                    text={item.label}
                    chipStatus={onGetLifecycleStatus?.(item.value)}
                    hideActionButton={!isActionEnabled}
                    onClose={() => handleRemove(item.value)}
                />
            ))}
        </StyledCheckboxFilterResultContainer>
    );
};

export default LeadScoreFilterResult;
